
import { FileTypeEnum } from '@/enum';
import {baseSplitApi} from '../base';
import { APIResponse } from '@/interfaces';

type BaseObject = {
  type: FileTypeEnum;
  formData: FormData;
  onUploadProgress?: (progress: number) => void;
};
export interface FileUpload {
  status: string;
  createdBy: string;
  key: string;
  type: string;
  _id: string;
  createdAt: Date;
  updatedAt: Date;
  version: number;
  url: string;
}

export const fileApi = baseSplitApi.injectEndpoints({
  endpoints: builder => ({
    uploadFile: builder.mutation<APIResponse<FileUpload>, BaseObject>({
      query: ({formData, type, onUploadProgress}) => ({
        url: '/v1/file',
        method: 'POST',
        body: formData,
        params: {type},
        onProgress: (event: ProgressEvent) => {
          if (event.lengthComputable && onUploadProgress) {
            const progress = Math.round((event.loaded / event.total) * 100);
            onUploadProgress(progress);
          }
        },
        transformResponse: (response: {data: {url: string}}) =>
          response.data.url,
      }),
    }),
  }),
});
export const {useUploadFileMutation} = fileApi;
